import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'

import { ChartsModule } from 'ng2-charts';

import { IncrementadorComponent } from './incrementador/incrementador.component';
import { DonaComponent } from './dona/dona.component';
import { CalificacionesReportComponent } from './calificaciones-report/calificaciones-report.component';
import { PagosReportComponent } from './pagos-report/pagos-report.component';



@NgModule({
  declarations: [
    IncrementadorComponent,
    DonaComponent,
    CalificacionesReportComponent,
    PagosReportComponent,
    
  ],
  exports: [
    IncrementadorComponent,
    DonaComponent,
    CalificacionesReportComponent,
     PagosReportComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ChartsModule
  ]
})
export class ComponentsModule { }
